"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var editable_text_option_row_styles_1 = require("./editable-text-option-row.styles");

var editable_text_optoin_view_container_1 = __importDefault(require("../editable-text-option-view/editable-text-optoin-view.container"));

var remove_option_button_container_1 = __importDefault(require("../remove-option-button/remove-option-button.container"));

var editable_action_view_component_1 = __importDefault(require("../editable-action-view/editable-action-view.component"));

var EditableTextOptionRow = function EditableTextOptionRow(_ref) {
  var nodeId = _ref.nodeId,
      optionIndex = _ref.optionIndex,
      option = _ref.option,
      handleMouseEnter = _ref.handleMouseEnter,
      handleMouseLeave = _ref.handleMouseLeave;
  return react_1.default.createElement(editable_text_option_row_styles_1.WrapperDiv, {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, react_1.default.createElement(editable_text_option_row_styles_1.TextOptionViewWrapperDiv, null, react_1.default.createElement(editable_text_optoin_view_container_1.default, {
    nodeId: nodeId,
    optionIndex: optionIndex,
    option: option
  }), react_1.default.createElement(editable_text_option_row_styles_1.RemoveButtonWrapperDiv, null, react_1.default.createElement(remove_option_button_container_1.default, {
    nodeId: nodeId,
    optionIndex: optionIndex
  }))), react_1.default.createElement(editable_action_view_component_1.default, {
    nodeId: nodeId,
    optionIndex: optionIndex,
    option: option
  }));
};

exports.default = EditableTextOptionRow;